<template>
	<v-container
		fluid
		class="login-contianer animate__animated animate__fadeIn"
	>
		<v-row style="height: 100vh;">
			<!-- Panel Right -->
			<v-col
				md="7"
				cols="12"
				v-if="$vuetify.breakpoint.mdAndUp"
				style="height: 100vh; z-index: 10;"
				class="d-flex flex-column justify-center white--text pl-15 panel-left height-full"
			>
				<div>
					<h1 style="font-size: 4rem;">
						Portal de pedidos
					</h1>
					<h3 style="letter-spacing: 1px;">
						Para clientes de Pinturas Acuario
					</h3>
					<p
						class="mt-5"
						style="letter-spacing: .4px; line-height: 25px; width: 90%;"
					>
						Conozca la gran variedad de productos que Pinturas
						Acuario tiene para usted. <br />
						¡Encuentre el producto ideal para su proyecto!
					</p>
				</div>
			</v-col>

			<!-- Panel Left -->
			<v-col
				md="5"
				cols="12"
				offset-md="0"
				:class="[
					'height-full',
					'd-flex',
					'align-start',
					'pt-0',
					'mt-15',
					$vuetify.breakpoint.mdAndUp ? 'pl-10 pr-15' : 'pl-5 pr-5',
				]"
			>
				<v-container>
					<v-row>
						<v-col cols="12">
							<!-- Router View -->
							<router-view></router-view>
						</v-col>

						<v-col
							cols="12"
							:class="[
								'pt-0',
								'mt-12',
								'd-flex',
								'justify-center',
							]"
							style="color: #888;"
						>
							Siganos en nuestras redes sociales
						</v-col>
						<v-col
							cols="12"
							:class="[
								'pt-0',
								'pb-0',
								'd-flex',
								'justify-center',
							]"
						>
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										v-bind="attrs"
										v-on="on"
										class="mx-3"
										icon
										target="blank"
										href="https://www.facebook.com/PinturasAcuarioOficial"
									>
										<v-icon size="24px" color="#999">
											mdi-facebook
										</v-icon>
									</v-btn>
								</template>
								<span>Facebook</span>
							</v-tooltip>

							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										v-bind="attrs"
										v-on="on"
										class="mx-3"
										icon
										target="blank"
										href="https://www.instagram.com/pinturasacuario"
									>
										<v-icon size="24px" color="#999">
											mdi-instagram
										</v-icon>
									</v-btn>
								</template>
								<span>Instagram</span>
							</v-tooltip>

							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										v-bind="attrs"
										v-on="on"
										class="mx-3"
										icon
										target="blank"
										href="https://www.youtube.com/channel/UC0rIvyVx90d-iwgfiKPDwFQ"
									>
										<v-icon size="24px" color="#999">
											mdi-youtube
										</v-icon>
									</v-btn>
								</template>
								<span>YouTube</span>
							</v-tooltip>

							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										v-bind="attrs"
										v-on="on"
										class="mx-3"
										icon
										target="blank"
										href="https://twitter.com/pint_acuario"
									>
										<v-icon size="24px" color="#999">
											mdi-twitter
										</v-icon>
									</v-btn>
								</template>
								<span>Twitter</span>
							</v-tooltip>
						</v-col>
					</v-row>
				</v-container>
			</v-col>
		</v-row>
		<!-- <div class="by">
			Developed by:
			<a
				href="https://twitter.com/JoseAngelMMtz"
				target="_blank"
				class="ml-2"
				>@JAMM</a
			>
		</div> -->

		<img
			src="/img/wave.svg"
			alt=""
			class="wave"
			v-if="$vuetify.breakpoint.mdAndUp"
		/>

		<img
			src="https://apps.pinturasacuario.mx/assets/logo-blanco-transparente.png"
			alt=""
			v-if="$vuetify.breakpoint.mdAndUp"
			class="logo"
		/>

		<!-- <v-btn
			fab
			elevation="1"
			@click="navigationToggle()"
			style="position: absolute; left: 20px; top: 20px;"
		>
			<v-icon class="black--text">
				mdi-menu
			</v-icon>
		</v-btn> -->

		<img
			src="https://apps.pinturasacuario.mx/assets/pa-logo-bg-blanco-padding-0.jpg"
			alt=""
			class="logo-sm-n-down"
			v-if="$vuetify.breakpoint.smAndDown"
		/>

		<!-- Botón guia de usuario -->
		<v-tooltip
			:right="$vuetify.breakpoint.mdAndUp"
			:left="$vuetify.breakpoint.smAndDown"
			v-model="ui.btnManual"
		>
			<template v-slot:activator="{ on, attrs }">
				<v-btn
					fab
					v-on="on"
					color="orange"
					v-bind="attrs"
					@click="abrirManualUsuario()"
					:large="$vuetify.breakpoint.mdAndUp"
					class="btn-handbook white--text elevation-10 animate__animated animate__heartBeat animate__repeat-3"
				>
					<v-icon>
						mdi-book
					</v-icon>
				</v-btn>
			</template>
			Manual de usuario
		</v-tooltip>
	</v-container>
</template>

<script>
import { EventBus } from "@/main";

export default {
	name: "Index",

	data() {
		return {
			ui: {
				btnManual: true,
			},
		};
	},

	methods: {
		navigationToggle() {
			EventBus.$emit("navigationToggle");
		},

		abrirManualUsuario() {
			window.open(
				"https://apps.pinturasacuario.mx/assets/store/manual_usuario.pdf"
			);
		},
	},
};
</script>

<style lang="css" scoped>
.wave {
	position: absolute;
	z-index: 20;
	transform: rotate(-90deg);
	right: 3%;
	top: 35%;
}

.by {
	display: flex;
	justify-content: flex-end;
	position: absolute;
	bottom: 0;
	padding: 2% 3%;
	left: 0;
	font-size: 0.9rem;
	width: 100%;
	height: 20px;
	z-index: 5;
}

.login-contianer {
	padding: 0;
	height: 100vh;
	position: fixed;
	/*overflow: hidden !important;*/
}

.logo {
	width: 175px;
	position: absolute;
	z-index: 20;
	top: 50px;
	left: 50px;
}

.store-icon {
	position: absolute;
	z-index: 10;
	top: 2%;
	right: 2%;
}

.logo-sm-n-down {
	position: absolute;
	height: 35px;
	right: 20px;
	top: 30px;
}

.btn-handbook {
	cursor: pointer;
	position: fixed;
	top: 85%;
	left: 40px;
	z-index: 10;
}

/*Panel left*/
.panel-left {
	background: linear-gradient(-45deg, #005cb9, #0099ff, #005eb8, #0099ff);
}

/*Extra small < 600px*/
@media (min-width: 0) and (max-width: 960px) {
	.btn-handbook {
		position: fixed;
		top: 90%;
		left: 80%;
	}
}

@media (min-height: 0) and (max-height: 600px) {
	.btn-handbook {
		display: none;
	}
}
</style>
